import { melbourneDate } from '../../../shared/dates';
import { type SocialAssetWithProject } from '../../../shared/types';
import { formatDate, formatWeekdayDate } from '../../lib/calendar';
import { assetChannels, channelLabel, type SocialActions } from '../../lib/socialCalendar';
import { Sheet, SheetButton, SheetRow } from '../Sheet';
import { CalendarIcon, CheckIcon, RepeatIcon, SocialIcon, XIcon } from '../icons';

// ── Slot actions sheet (mockup §10.1 B note) ─────────────────────────────

export function SlotActionsSheet({
  asset,
  actions,
  onMoveDate,
  onEditChannels,
  onClose,
}: {
  asset: SocialAssetWithProject;
  actions: SocialActions;
  onMoveDate: () => void;
  onEditChannels: () => void;
  onClose: () => void;
}) {
  const used = asset.status === 'used';
  const context = [
    asset.planned_date === null ? 'unplanned' : formatWeekdayDate(asset.planned_date),
    channelLabel(assetChannels(asset.channels)),
    ...(asset.project_name !== null ? [asset.project_name] : []),
  ].join(' · ');
  const run = (fn: () => void) => () => {
    onClose();
    fn();
  };
  return (
    <Sheet
      open
      onClose={onClose}
      variant="half"
      title={asset.label}
      context={context}
      rightAction={<SheetButton onClick={onClose}>Close</SheetButton>}
      className="social-m-sheet"
    >
      {used ? (
        <>
          <div className="social-m-note">
            <p>
              Posted {formatDate(melbourneDate(asset.used_at ?? asset.updated_at))} · used posts stay
              as history. Repurpose makes a fresh asset from this one.
            </p>
          </div>
          <SheetRow icon={<RepeatIcon />} label="Repurpose" onSelect={run(() => actions.onRepurpose(asset))} />
        </>
      ) : (
        <>
          <SheetRow icon={<CheckIcon />} label="Mark used today" onSelect={run(() => actions.onMarkUsed(asset))} />
          <SheetRow icon={<CalendarIcon />} label="Move date" onSelect={run(onMoveDate)} />
          <SheetRow icon={<SocialIcon />} label="Edit channels" onSelect={run(onEditChannels)} />
          <SheetRow icon={<XIcon />} label="Unschedule" onSelect={run(() => actions.onUnschedule(asset))} />
        </>
      )}
    </Sheet>
  );
}
